import { useState } from 'react'
import Intro from './components/Intro.jsx'
import Projects from './components/Projects.jsx'
import Services from './components/Services.jsx'
import Contact from './components/Contact.jsx'
import Privacy from './components/Privacy.jsx'
import Overlay from './components/Overlay.jsx'

export default function App() {
  const [privacyOpen, setPrivacyOpen] = useState(false)
  const year = new Date().getFullYear()

  const loadModal = (event) => {
    event.preventDefault()
    if (event.target.id === 'privacyModal') {
      setPrivacyOpen(true)
    }
  }

  const dismissModal = (id) => {
    if (id === 'privacydismiss') {
      setPrivacyOpen(false)
    }
  }

  return (
    <div className="app">
      <div id="sections_container" className={privacyOpen ? 'is-hidden' : undefined}>
        <Intro />
        <Projects />
        <Services />
        <Contact />
        <Overlay>
          <div className="footer-mandril">
            <div className="row">
              <div className="col-xs-2 col-xs-offset-3 right">
                <a href="https://www.linkedin.com/in/julian-marquez-c" target="_blank">
                  <div className="card-gradient">
                    <i className="fab fa-linkedin-in"></i>
                  </div>
                </a>
              </div>
              <div className="col-xs-2 center">
                <a href="https://github.com/piyiyo" target="_blank">
                  <div className="card-gradient">
                    <i className="fab fa-github"></i>
                  </div>
                </a>
              </div>
              <div className="col-xs-2 left">
                <a href="https://www.npmjs.com/~piyiyo" target="_blank">
                  <div className="card-gradient">
                    <i className="fab fa-npm"></i>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <p>
                {' '}
                © {year} MandrilSoft.&nbsp;&nbsp;&nbsp;&nbsp;
                <a href="" id="privacyModal" onClick={loadModal}>
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        </Overlay>
      </div>
      <Privacy dismissModal={dismissModal} isOpen={privacyOpen} />
    </div>
  )
}
